import { render, staticRenderFns } from "./BalancoHidrico.vue?vue&type=template&id=76813c38&"
import script from "./BalancoHidrico.vue?vue&type=script&lang=js&"
export * from "./BalancoHidrico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports